import { useNavigate, type NavigateFunction } from "react-router-dom";
import { useRoutes } from "react-router-dom";
import { useEffect, Suspense } from "react";
import routes from "./config";

let navigateResolver: (navigate: ReturnType<typeof useNavigate>) => void;

declare global {
  interface Window {
    REACT_APP_NAVIGATE: ReturnType<typeof useNavigate>;
  }
}

export const navigatePromise = new Promise<NavigateFunction>((resolve) => {
  navigateResolver = resolve;
});

export function AppRoutes() {
  const element = useRoutes(routes);
  const navigate = useNavigate();
  useEffect(() => {
    window.REACT_APP_NAVIGATE = navigate;
    navigateResolver(window.REACT_APP_NAVIGATE);
  });
  
  return (
    <Suspense 
      fallback={
        <div className="min-h-screen bg-gradient-to-br from-[#0A0F1E] via-[#0D1425] to-[#0A0F1E] flex items-center justify-center">
          <div className="text-center">
            <div className="inline-flex items-center gap-3 mb-4">
              <img 
                src="https://static.readdy.ai/image/3e6f353e8dbbec4f9360c3b978f4989c/5f6efc2ffdcd0c86f2a49b96b7b50d51.png" 
                alt="طيبات الطبية العالمية" 
                className="h-12 w-auto animate-pulse"
              />
            </div>
            <div className="flex items-center gap-2 text-[#00FF94]">
              <i className="ri-loader-4-line animate-spin text-2xl"></i>
              <span className="text-lg">جاري التحميل...</span>
            </div>
          </div>
        </div>
      }
    >
      {element}
    </Suspense>
  );
}
